import EventCourtesyFormWidget from './components/EventCourtesyRequestForm/widget.svelte';

var div = document.getElementById('cobraticket-event-courtesy-form');
let embed;
if (div) {
	var script = document.currentScript;
	var attributes: any = {};
	if (script) {
		script.parentNode?.appendChild(script);
		for (var i = 0; i < script.attributes.length; i++) {
			var attr = script.attributes[i];
			attributes[attr.name] = attr.value;
		}
	}
	console.log('attributes', attributes);
	embed = new EventCourtesyFormWidget({
		target: div,
		props: {
			publicKey: attributes['public-key'],
			primaryColor: attributes['primary-color'],
			buttonText: attributes['button-text'],
			eventCode: attributes['event-code'],
			invitationCode: attributes['invitation-code'],
			ticketTypeCode: attributes['ticket-type-code'],
			autoValidationCode: attributes['autovalidation-code'],
			borderRadius: attributes['border-radius']
		}
	});
}
export default embed;
